<aside class="side-panel overflow-allowed" [attr.tabindex]="sidePanel.visible ? 0 : -1" [ngStyle]="{'top.px': top, 'bottom.px': bottom}"  [ngClass]="{ 'visible': sidePanel.visible, 'left' : isLeftSide, 'thin' : isThin, 'below-mega-menu' : belowMegaMenu, 'show-tabs-for-phone-only' : showTabsForPhoneOnly, 'no-padding': !hostPadded, 'extra-wide': extraWide}" aria-label="Side Panel" [attr.aria-hidden]="!sidePanel.visible" [attr.inert]="sidePanel.visible ? null : ''">
  @if (showCloseButton) {
    <button class="side-panel-close" aria-label="Close Side Panel" (click)="closePanel()">&times;</button>
  }
  <!-- TODO: Tabs need to be updated for 508 compliance -->
  @if (sidePanel.tabs.length > 1 || forceSingleTab) {
    <div class="side-panel-tabs" [ngClass]="{'show-for-small-only' : showTabsForPhoneOnly}">
      <ul class="no-bullet" [ngClass]="calcClass(sidePanel.tabs.length)">
        @for (tab of sidePanel.tabs; track tab; let i = $index) {
          <li class="display-inline-block" [ngClass]="{ 'active': curTab == i }" (click)="selectTab(i)">{{tab.title}}</li>
        }
      </ul>
    </div>
  }

  @for (section of sidePanel.sections; track section; let x = $index) {
    <section>
      @if (curTab == x) {
        <div class="content grid-y">
          <ng-template dynamic-component-loader [componentName]="section.componentName" [componentInjector]="sidePanel?.injector" [componentData]="section.componentData" (save)="section.method($event)"></ng-template>
        </div>
      }
    </section>
  }
</aside>